"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLabel = addLabel;
exports.attachLabel = attachLabel;
exports.deleteLabel = deleteLabel;
exports.editLabel = editLabel;
exports.labelPage = labelPage;
exports.memberLabels = memberLabels;
var _request = _interopRequireDefault(require("@/utils/request"));
// 会员标签管理列表
function labelPage(data) {
  return (0, _request.default)({
    url: '/portal/system/label/labelPage',
    method: 'post',
    data: data
  });
}
function addLabel(data) {
  return (0, _request.default)({
    url: '/portal/system/label/addLabel',
    method: 'post',
    data: data
  });
}
function editLabel(data) {
  return (0, _request.default)({
    url: '/portal/system/label/editLabel',
    method: 'post',
    data: data
  });
}
function deleteLabel(data) {
  return (0, _request.default)({
    url: '/portal/system/label/deleteLabel',
    method: 'post',
    data: data
  });
}
// 会员标签列表
function memberLabels(data) {
  return (0, _request.default)({
    url: '/portal/system/label/memberLabels',
    method: 'post',
    data: data
  });
}
// 会员标签绑定
function attachLabel(data) {
  return (0, _request.default)({
    url: '/portal/system/label/attachLabel',
    method: 'post',
    data: data
  });
}